<script setup lang="ts">
import BaseRadioGroup from '@/components/ui/BaseRadioGroup.vue';
import BaseRadio from '@/components/ui/BaseRadio.vue';
import { $t } from '@/composables/translations/useTranslate';

// Fixed value - bank transfer is the only option for now
const selectedPaymentMethod = 'bank-transfer';
</script>

<template>
  <div class="checkout-payment-method mb-8">
    <BaseRadioGroup name="payment-method" :model-value="selectedPaymentMethod">
      <BaseRadio
        id="payment-bank-transfer"
        name="payment-method"
        value="bank-transfer"
        :label="
          $t(
            'ibe.checkout.payment.bank-transfer',
            'I will transfer the amount after receiving the invoice.'
          )
        "
        :model-value="selectedPaymentMethod"
      />
    </BaseRadioGroup>
  </div>
</template>
